export const error = (state = {}, action) => {
    const { error } = action.payload;
    if (!error) {
        return state;
    }
    if (error.modelState) {
        return error.modelState;
    }
    if (error.name === 'ValidationError') {
        return {
            [error.path]: error.errors,
        };
    }
    // ASP.NET [ApiController] returns ValidationProblemDetails: the per-field
    // errors live under .errors, while .type/.title/.status/.traceId sit at the
    // top level. Unwrap so field keys end up at the top of the reducer state.
    const source =
        error.errors &&
        typeof error.errors === 'object' &&
        !Array.isArray(error.errors)
            ? error.errors
            : error;

    if (typeof source === 'object') {
        const errorFormatted = {};
        Object.keys(source).forEach((key) => {
            errorFormatted[_camelCase(key)] = source[key];
        });
        return errorFormatted;
    }

    return state;
};

const _camelCase = (input) => {
    if (typeof input !== 'string') return '';
    return input.charAt(0).toLocaleLowerCase() + input.slice(1);
};
